/*
 * @Author: Teemo Ding
 * @Date: 2021-12-16 16:45:24
 * @LastEditTime: 2021-12-17 10:41:50
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Cascader/CascaderObjectValue.tsx
 */
import { Cascader } from 'antd';
import React from 'react';

const CascaderObjectValue = (props) => {
  const { children, value, fieldNames, onChange, ...rest } = props;
  const valueAll = value.map((item) => item[fieldNames.value]);
  const onSelectChange = (value, selectedOptions) => {
    onChange(selectedOptions);
  };
  return (
    <Cascader
      value={valueAll.length ? valueAll : null}
      onChange={onSelectChange}
      fieldNames={fieldNames}
      {...rest}>
      {children}
    </Cascader>
  );
};

export default CascaderObjectValue;
